<template>
  <div class='topic-edit-component page-module-wrap'>
    <div class='form-wrap'>
      <div class='topic-basic-information'>
        <div class='topic-name-wrap'>
          <div class='label'>专题名称<span class='red'> *</span>
            <el-checkbox style="margin-left: 20px;padding-top: 5px" v-model="result.isShowTitle">显示标题</el-checkbox>
          </div>
          <div class='input-wrap'>
            <limit-input :value.sync='result.title' :limit-number='18' :placeholder='"请输入专题名称"'></limit-input>
          </div>
        </div>
        <div class='topic-name-wrap'>
          <div class='label'>专题名称颜色</div>
          <div class='input-wrap'><input type="color" class='width-2' placeholder="请输入内容" v-model='result.color'></div>
        </div>
        <div class='topic-desc-wrap'>
          <div class='label'>专题描述</div>
          <div class='input-wrap'>
             <limit-input :value.sync='result.brief' :limit-number='18' :placeholder='"请输入专题描述"'></limit-input>
          </div>
        </div>
        <div class='status-wrap'>
          <div class='label'>显示状态</div>
          <div class='radio-wrap'>
            <p class="control">
              <label class="radio">
                <input type="radio" value="0" name='status' v-model='result.status'>永久关闭
              </label>
            </p>
            <p class="control">
              <label class="radio">
                <input type="radio" value="2" name='status' v-model='result.status'>定时开关
              </label>
            </p>
          </div>
          <div class='datetime-wrap' v-show="result.status == 2">
            <el-date-picker
              v-model="result.time"
              type="datetimerange"
              placeholder="选择时间范围">
            </el-date-picker>
          </div>
          <div class='category-wrap'>
            <div class='label'>分类</div>
            <div>
              <span class="select">
                <select v-model='result.categoryId'>
                  <option value="-1">不设置分类</option>
                  <option v-for='category in initData.topicCategories' :value="category.categoryId">{{category.name}}</option>
                </select>
              </span>
            </div>
          </div>
          <div class='upload-wrap'>
            <div class='label'>封面图</div>
            <div class="button-wrap">
              <span class="button is-primary" id="bannerUploadBtn">上传图片</span>
              <span><span class='red'>建议尺寸：750*428px</span> 只能上传 jpg/png 文件，且不超过 1MB</span>
            </div>
            <div class="img-wrap">
              <image-component v-show='result.banner.image' :image="result.banner" :width="300"></image-component>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h1>专题规则设置
        <el-tooltip content='一个专题可添加多个规则,多个规则之间为"或关系";同一个规则中,可同时设置ICON和标签,此时ICON和标签为"与关系",即需同时满足' placement="right">
          <span class='cursor-point'><i class='fa fa-question-circle'></i></span>
        </el-tooltip>
        </h1>
        <div class='rule-wrap' v-for='(rule,index) in rules'>
          <div class='icon-wrap'>
            <label class="label inline-block r-top">选择ICON：</label>
            <v-select class='v-select'
              v-model="rule.bloggers"
              :options="initData.bloggers"
              placeholder="请选择"
              :show-labels='false'
              :multiple="true"
              track-by="name"
              label="name">
            </v-select>
            <div class='delete-rule button is-danger' @click="deleteRule(index)">删除</div>
          </div>
          <div class='tag-wrap'>
            <label class="label inline-block r-top">选择标签：(非必填)</label>
            <v-select class='v-select'
              v-model="rule.selectedTags"
              :options="initData.tags"
              placeholder="请选择"
              :show-labels='false'
              :multiple="true"
              track-by="tagName"
              label="tagName">
            </v-select>
          </div>
          <div class='tag-model-wrap' v-show='rule.selectedTags.length > 1'>
            <label class="label inline-block r-top">关联关系：</label>
            <label class="radio">
              <input type="radio" value="0" :name="'tagModel'+index" v-model='rule.tagModel'>同时满足
            </label>
            <label class="radio">
              <input type="radio" value="1" :name="'tagModel'+index" v-model='rule.tagModel'>满足任意一条
            </label>
          </div>
        </div>
        <button class="add-rule-button button is-primary" @click='addRule'>增加规则</button>
        <div class='dynamic-id-wrap'>
          <div class='label'>输入动态ID</div>
          <div class='dynamic-id-input-wrap'><input class='input' type="text" v-model='dynamicId' placeholder="输入完成之后请按添加按钮"><button class="button is-primary" @click='addDynamicId'>添加</button></div>
          <div class='dynamic-id'>
            <span class='dynamic-id-item' v-for='(item,index) in result.dynamicIds'><span>{{item}}</span><span class='del' @click='deleteDynamicId(index)'>x</span></span>
          </div>
        </div>
      </div>
      <div id='topic-page-setting'>
        <h1>专题页设置</h1>
        <div class="page-setting-wrap">
          <div class="goods-category-select">
            <div class='label'>商品类目选择：</div>
            <div class='radion-wrap'>
              <el-radio-group v-model="result.isAllCategory" @change="changeValue">
                <el-radio :label="0">部分显示</el-radio>
                <el-radio :label="1">全部显示</el-radio>
              </el-radio-group>
            </div>
            <div class='tag-wrap'>
              <v-select class='v-select'
                        v-model="categoryNames"
                        :options="secondCategories"
                        placeholder="请选择"
                        :show-labels='false'
                        :multiple="true"
                        :disabled="flag"
                        track-by="name"
                        label="name">
              </v-select>
            </div>
          </div>
          <div class='topic-content-setting'>
            <div class='label'>专题正文(可不填)</div>
            <div>
              <textarea class="textarea theme-article content-input" v-model="result.description"></textarea>
            </div>
          </div>
          <div class="radion-wrap">
            <label class='label inline-block r-top'>正文排版：</label>
            <label class="radio">
              <input type="radio" :value="0" name='descriptionAlign' v-model='result.descriptionAlign'>左对齐
            </label>
            <label class="radio">
              <input type="radio" :value="1" name='descriptionAlign' v-model='result.descriptionAlign'>居中
            </label>
            <label class="radio">
              <input type="radio" :value="2" name='descriptionAlign' v-model='result.descriptionAlign'>右对齐
            </label>
          </div>
          <div class='radion-wrap'>
            <label class='label inline-block r-top'>关联ICON显示:</label>
            <label class="radio">
              <input type="radio" value="0" name='relativeIcon' v-model='result.showRelated'>关闭
            </label>
            <label class="radio">
              <input type="radio" value="1" name='relativeIcon' v-model='result.showRelated'>开启
            </label>
          </div>
          <div class='relative-title-wrap'>
            <div class='label'>关联ICON栏标题</div>
            <div><input class='input relative-input' type="text" v-model='result.relatedTitle'></div>
          </div>
          <div class='hot-map-wrap'>
            <div class='label'>添加图片热区</div>
            <div class="button-wrap">
              <button class="button is-primary" id="js_hotImageUploadBtn">上传图片</button>
              <button class="button is-danger" @click='deleteHotImage'>删除图片</button>
              <span>只能上传 jpg/png 文件，且不超过 1MB</span>
            </div>
            <div class="img-wrap" :style="{width: result.hotImage+'px'}">
              <image-component id="hotShotImg" :image="result.hotImage" :width="result.hotImage.width"></image-component>
            </div>
            <div class='table-wrap' v-show='result.hotImage.image'>
              <table class='table is-bordered'>
                <thead><tr><td>选中</td><td>名称</td><td>链接</td><td>位置</td><td>删除</td></tr></thead>
                <tbody>
                  <tr v-for='(hotMap,index) in hotMaps'>
                    <td><div class='radio-wrap'>
                    <input type="radio" name='hotMap' :value='index' v-model='hotMapIndex' @click='hotMapRadioClick(index)'>
                    </div></td>
                    <td><input class='input' type="text" v-model='hotMap.title'></td>
                    <td>
                    <custom-link :link='hotMap.link' @update:link="val => { hotMap.link = val }"></custom-link>
                    <td>{{Object2String(hotMap.data)}}</td>
                    <td><button class='button is-danger' @click='deleteHotMapItem(index)'>删除</button></td>
                  </tr>
                </tbody>
              </table>
              <div class='clearfix'><button class="button is-primary fright" @click='addHotMap'>添加热点</button></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class='foot'>
      <button class='button is-primary' @click='doSave'>保存</button>
      <button class='button' @click="goBack">返回</button>
    </div>
  </div>
</template>

<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import $ from 'expose-loader?$!jquery'
import 'COMMON/imgAreaSelect/imgareaselect-default.css'
import 'COMMON/imgAreaSelect/jquery.imgareaselect.js'
import CustomLink from 'COMMON/DefinedLink'
import { formatDate } from 'UTILS/date'
import LimitInput from 'COMMON/limitInput'
import VSelect from 'vue-multiselect'

const OPERATION_TYPE = 'A'
const PROPERTIES_TYPE = 'B'

export default {
  data () {
    return {
      adId: 0,
      result: {
        time: [],
        title: '',
        color: '#FFFFFF',
        brief: '',
        description: '',
        descriptionAlign: 0, // 默认0：左对齐  1：居中  2：右对齐
        status: 0,
        startTime: '',
        endTime: '',
        categoryId: -1,
        banner: {
          image: '',
          width: 0,
          height: 0
        },
        dynamicIds: [],
        showRelated: 0,
        relatedTitle: '',
        hotImage: {
          image: '',
          width: 0,
          height: 0
        },
        isAllCategory: 0, // 商品类目是否全部选择0：部分选择1：全部选择
        isShowTitle: 0
      },
      initData: {
        topicCategories: [],
        operationTags: [],
        propertiesTags: [],
        bloggers: [],
        tags: []
      },
      rules: [
        {
          bloggers: [],
          selectedTags: [],
          tagModel: 0
        }
      ],
      dynamicId: '',
      hotMaps: [
        {
          data: {},
          link: '',
          linkId: '',
          title: ''
        }
      ],
      hotMapIndex: 0,
      imgSelect: null,
      modal: {
        title: '编辑自定义链接',
        visible: false,
        link: ''
      },
      secondCategories: [],
      flag: false,
      categoryNames: []
    }
  },
  components: {CustomLink, LimitInput, VSelect},
  mounted () {
    this.getInitData()
    this.getSecondCategory()
    this.uploadMainBind()
    this.uploadBanner()
    if (this.$route.query.topicId) {
      let params = {
        topicId: this.$route.query.topicId
      }
      HttpRequest.get('/admin.php?method=blogger.getTopic', params).then(response => {
        this.result.descriptionAlign = response.data.descriptionAlign
        this.result.title = response.data.name
        this.result.color = response.data.color ? response.data.color : this.result.color
        this.result.brief = response.data.brief
        this.result.description = response.data.description
        this.result.dynamicIds = response.data.dynamicIds
        this.result.isShowTitle = !!response.data.isShowTitle
        this.result.time.push(formatDate(response.data.startTime, 'yyyy-MM-dd hh:mm:ss'))
        this.result.time.push(formatDate(response.data.endTime, 'yyyy-MM-dd hh:mm:ss'))

        if (response.data.status == 1 && (response.data.startTime || response.data.endTime)) {
          this.result.status = 2
        } else {
          this.result.status = response.data.status
        }
        this.result.categoryId = response.data.categoryId
        this.result.banner = response.data.banner ? response.data.banner : this.result.banner
        this.result.showRelated = response.data.showRelated
        this.result.relatedTitle = response.data.relatedTitle
        this.result.isAllCategory = response.data.isAllCategory
        this.hotMaps = response.data.rect
        if (response.data.categoryNames) {
          response.data.categoryNames.forEach((item) => {
            this.categoryNames.push({name: item})
          })
        }
        if (this.hotMaps.length) {
          this.bindImageSelect(this.hotMaps[0].data)
        }

        this.result.hotImage = response.data.hotImage ? response.data.hotImage : this.result.hotImage

        this.rules = response.data.rule.map((item) => {
          let params = {}
          params.bloggers = item.bloggers
          params.tagModel = item.tagModel

          params.selectedTags = item.operationTags.map((item) => {
            item['type'] = OPERATION_TYPE
            return item
          }).concat(
            item.propertiesTags && item.propertiesTags.map((item) => {
              item['type'] = PROPERTIES_TYPE
              return item
            })
          ).filter((item) => { return item })
          return params
        })
      })
    }
  },
  methods: {
    changeValue (value) {
      if (value === 0) {
        this.flag = false
      }
      if (value === 1) {
        this.categoryNames = []
        this.flag = true
      }
    },
    getSecondCategory () {
      HttpRequest.get('/admin.php?method=aicategoryinfo.getAiSecondCategoryList').then((response) => {
        this.secondCategories = response.data.list ? response.data.list : this.secondCategories
      })
    },
    goBack () {
      this.$router.push({
        name: 'cyzsTopicList',
        query: {
          page: this.$route.query.page,
          searchParams: this.$route.query.searchParams
        }
      })
    },
    getInitData () {
      HttpRequest.get('/admin.php?method=blogger.getTopicInit').then(response => {
        this.initData.topicCategories = response.data.topicCategories
        this.initData.operationTags = response.data.operationTags
        this.initData.bloggers = response.data.bloggers
        this.initData.propertiesTags = response.data.propertiesTags ? response.data.propertiesTags : this.initData.propertiesTags
        this.initData.tags = this.initData.operationTags.map((item) => {
          item['type'] = OPERATION_TYPE
          item['tagId'] = item['tagId']
          return item
        }).concat(
          this.initData.propertiesTags.map((item) => {
            item['type'] = PROPERTIES_TYPE
            item['tagId'] = item['tagId']
            return item
          })
        )
      })
    },
    addRule () {
      this.rules.push({bloggers: [], selectedTags: []})

      if (this.hotMaps[this.hotMapIndex] && this.hotMaps[this.hotMapIndex].data) {
        this.bindImageSelect(this.hotMaps[this.hotMapIndex].data)
      }
    },
    deleteRule (index) {
      this.rules.splice(index, 1)
      if (this.hotMaps[this.hotMapIndex] && this.hotMaps[this.hotMapIndex].data) {
        this.bindImageSelect(this.hotMaps[this.hotMapIndex].data)
      }
    },
    addDynamicId () {
      if (!this.dynamicId.trim()) {
        this.$message('动态ID不能为空')
        return
      }
      if (this.result.dynamicIds.indexOf(JSON.parse(this.dynamicId.trim())) > -1) {
        this.$message('该ID已存在')
      } else {
        this.result.dynamicIds.push(this.dynamicId.trim())
        this.dynamicId = ''
      }
    },
    deleteDynamicId (index) {
      this.result.dynamicIds.splice(index, 1)
    },
    editCustomerLink (index) {
      if (index == this.hotMapIndex) {
        this.modal.link = this.hotMaps[index].link
        this.modal.visible = true
      } else {
        this.$message('只能操作选中的热点')
      }
    },
    hotMapRadioClick (index) {
      if (this.hotMaps[index] && this.hotMaps[index].data) {
        this.bindImageSelect(this.hotMaps[index].data)
      } else {
        this.bindImageSelect()
      }
    },
    deleteHotImage () {
      if (this.result.hotImage.image) {
        if (confirm('确定删除?')) {
          this.result.hotImage = {
            image: '',
            width: 0,
            height: 0
          }
          this.initImageSelect()
        }
      } else {
        this.$message('请先上传图片')
      }
    },
    addHotMap () {
      this.hotMaps.push({index: this.hotMaps.length, data: {}, link: ''})
      if (this.hotMaps.length == 1) {
        this.hotMapIndex == 0
      } else {
        ++this.hotMapIndex
      }
      this.hotMapRadioClick(this.hotMapIndex)
    },
    deleteHotMapItem (index) {
      this.hotMaps.splice(index, 1)
      if (this.hotMaps.length > 0) {
        --this.hotMapIndex
      }
      this.hotMapRadioClick(this.hotMapIndex)
    },
    doSave () {
      if (!this.result.title) {
        this.$message('请填写名称')
        return
      }
      if (this.result.status == 2) {
        this.result.status = 1
      } else {
        this.result.startTime = ''
        this.result.endTime = ''
      }

      let temRules = []

      for (let rule of this.rules) {
        let params = {}

        params.bloggers = rule.bloggers
        params.tagModel = rule.tagModel
        params.operationTags = []
        params.propertiesTags = []

        for (let item of rule.selectedTags) {
          if (item.type == OPERATION_TYPE) {
            params.operationTags.push({tagId: item.tagId, tagName: item.tagName})
          } else if (item.type == PROPERTIES_TYPE) {
            params.propertiesTags.push({tagId: item.tagId, tagName: item.tagName})
          }
        }
        temRules.push(params)
      }

      let params = Object.assign({rules: JSON.stringify(temRules), rect: JSON.stringify(this.hotMaps)}, this.result)
      if (this.$route.query.topicId) {
        params.topicId = this.$route.query.topicId
      }
      params.categoryNames = []
      if (this.categoryNames.length !== 0) {
        this.categoryNames.forEach((item) => {
          params.categoryNames.push(item.name)
        })
      }
      params.isShowTitle = params.isShowTitle ? 1 : 0
      params.startTime = params.time[0] ? formatDate(new Date(params.time[0]).getTime(), 'yyyy-MM-dd hh:mm:ss') : ' '
      params.endTime = params.time[1] ? formatDate(new Date(params.time[1]).getTime(), 'yyyy-MM-dd hh:mm:ss') : ' '

      delete params['time']
      HttpRequest.post('/admin.php?method=blogger.doSaveTopic', params).then(response => {
        if (response.data.success) {
          this.$message('保存成功')
          setTimeout(() => {
            this.$router.push({
              name: 'cyzsTopicList',
              query: {
                page: this.$route.query.page,
                searchParams: this.$route.query.searchParams
              }
            })
          }, 2000)
        } else {
          this.$message('接口错误,请联系管理员')
        }
      })
    },
    initImageSelect () {
      this.imgSelect && this.imgSelect.setOptions({ hide: true })
      // this.hotMaps = [{data: {}, link: '', linkId: ''}],
      this.hotMapIndex = 0
    },
    Object2String (obj) {
      return JSON.stringify({x1: obj.x1, x2: obj.x2, y1: obj.y1, y2: obj.y2, width: obj.width, height: obj.height})
    },
    uploadBanner () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#bannerUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.result.banner.image = response.data.images.info.path
            this.result.banner.width = response.data.images.info.width
            this.result.banner.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_hotImageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image'
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.result.hotImage.image = response.data.images.info.path
            this.result.hotImage.width = response.data.images.info.width
            this.result.hotImage.height = response.data.images.info.height
            this.initImageSelect()
            this.bindImageSelect(this.hotMaps[this.hotMapIndex].data)
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    bindImageSelect (data = {}) {
      if (!(Object.keys(data).length)) {
        data = {x1: 0, y1: 0, x2: 100, y2: 100, width: 100, height: 100}
      }
      let that = this
      let obj = {
        handles: true,
        onSelectEnd (img, selection) {
          if (selection.width > 0 && selection.height > 0 && that.hotMaps[that.hotMapIndex]) {
            that.hotMaps[that.hotMapIndex].data = selection
          }
        }
      }
      this.$nextTick(() => {
        this.imgSelect = $('#hotShotImg').imgAreaSelect(Object.assign(data, obj, {instance: true}))
      })
    }
  },
  destroyed () {
    this.imgSelect && this.imgSelect.remove()
  }
}
</script>

<style lang="less" scoped>
  .input-wrap {
    margin: 10px 0;

    input {
      height: 32px;
      text-indent: 10px;
    }
  }
  .radio-wrap {
    margin: 10px 0 0;
  }
  .datetime-wrap {
    margin-bottom: 10px;
  }
  .upload-wrap {
    margin: 10px 0;
  }
  .button-wrap {
    margin: 10px 0;
    line-height: 32px;

    .img-wrap {
      margin: 10px 0;
    }
  }
  .rule-wrap, .tag-wrap {
    margin: 10px 0;
  }
  .icon-wrap, .tag-wrap {
    display: flex;

    .v-select {
      flex: 1;
      margin: 0 10px;
    }
  }
  .tag-name-wrap {
    padding-left: 80px;
    .tag-name {
      display: inline-block;
      border: 1px solid #ccc;
      padding: 2px 0 2px 10px;
      border-radius: 3px;
      margin-right: 8px;
    }
    .del {
      display: inline-block;
      width: 26px;
      height: 100%;
      cursor: pointer;
      text-align: center;
    }
  }
  .rule-wrap {
    position: relative;
    background: #f2f2f2;
    padding: 20px 50px;
    height: 157px;
  }
  .tag-model-wrap {
    padding-left: 100px;
  }
  .add-rule-button {
    width: 150px;
    margin: 10px 0;
  }
  .dynamic-id-wrap {
    margin-top: 20px;

    .dynamic-id-input-wrap {
      margin: 10px 0;

      input  {
        width: 300px;
        margin-right: 5px;
      }
    }
    .dynamic-id {
      min-height: 40px;
      margin-bottom: 10px;
    }
    .dynamic-id-item {
      display: inline-block;
      border: 1px solid #ccc;
      padding: 2px 0 2px 10px;
      border-radius: 3px;
      margin: 0 8px 5px 0;
      background-color: #e4e4e4;
    }
    .del {
      display: inline-block;
      padding: 5px;
      cursor: pointer;
    }
  }
  #topic-page-setting {
    .content-input, .radion-wrap, .relative-input {
      margin: 10px 0;
    }
    .radio {
      line-height: 30px;
      margin-left: 16px;
    }
  }
  .img-wrap {
    min-height: 100px;
  }
  h1 {
    font-size: 26px;
    margin: 30px 0;
    font-weight: bold;
  }
  .table-wrap {
    .radio-wrap {
      text-align: center;
    }
    .del {
      text-align: center;
      cursor: pointer;
      margin-top: 5px;
    }
  }
  .form-wrap {
    border: 1px solid #ccc;
    padding: 15px;
  }
  .foot {
    margin: 20px 0 50px;
    text-align: center;
  }
  .modal-wrap {
    min-height: 150px;
  }
  .theme-article {
    width: 100%;
    height: 100px;
  }

</style>
